// Intake — barrel export
// Chat atoms

export type { AiBubbleProps } from "./AiBubble";
export { AiBubble } from "./AiBubble";
export type { AvatarProps } from "./Avatar";
export { Avatar } from "./Avatar";
export type { BackTileProps } from "./BackTile";
export { BackTile } from "./BackTile";
export type { ChatComposerProps } from "./ChatComposer";
export { ChatComposer } from "./ChatComposer";
export type { ChatSrcChip, ChatSrcChipsProps } from "./ChatSrcChips";
export { ChatSrcChips } from "./ChatSrcChips";
export type { CitationData, CiteDetailProps } from "./CiteDetail";
// Rail components
export { CiteDetail } from "./CiteDetail";
export type { CiteHistoryProps } from "./CiteHistory";
export { CiteHistory } from "./CiteHistory";
export type { ConfirmGoBackModalProps } from "./ConfirmGoBackModal";
export { ConfirmGoBackModal } from "./ConfirmGoBackModal";
export type { ConfirmValuesProps } from "./ConfirmValues";
export { ConfirmValues } from "./ConfirmValues";
export type { EmptyStateProps } from "./EmptyState";
export { EmptyState } from "./EmptyState";
export type { FillInBlankProps, FillInBlankSegment } from "./FillInBlank";
export { FillInBlank } from "./FillInBlank";
/* ---------- Opportunity report (ported from `compass-oppreport.jsx`) ----------
 * The eight-section report surface. `report-fixtures` is exported deliberately:
 * it is the one typed dataset that drives every story and every app-side test,
 * so a §5 data gap closing is a one-line fixture change (see
 * docs/frontend/intake-report-port-plan.md). Same precedent as
 * MOCK_OPPORTUNITY_HISTORY. */
export type { FormulaTraceModalProps } from "./FormulaTraceModal";
export { FormulaTraceModal } from "./FormulaTraceModal";
export type { FunnelProps } from "./Funnel";
export { Funnel } from "./Funnel";
export type { InlineAdjustProps } from "./InlineAdjust";
export { InlineAdjust } from "./InlineAdjust";
export type {
  ChatHistoryMessage,
  IntakeChatHistoryProps,
} from "./IntakeChatHistory";
export { IntakeChatHistory } from "./IntakeChatHistory";
// Shared graph-prompt UI
export type {
  CheckboxListItem,
  IntakeCheckboxListProps,
} from "./IntakeCheckboxList";
export { IntakeCheckboxList } from "./IntakeCheckboxList";
export type { IntakeFooterBarProps } from "./IntakeFooterBar";
export { IntakeFooterBar } from "./IntakeFooterBar";
// Page components & orchestrators
export type { IntakeLayoutProps, IntakeStep } from "./IntakeLayout";
export { IntakeLayout } from "./IntakeLayout";
export type { IntakeMeasureProps } from "./IntakeMeasure";
export { IntakeMeasure } from "./IntakeMeasure";
export type { IntakeMetricSelectProps } from "./IntakeMetricSelect";
export { IntakeMetricSelect } from "./IntakeMetricSelect";
export type {
  IntakeModelStatusProps,
  ModelSnapshotStatus,
} from "./IntakeModelStatus";
export { IntakeModelStatus } from "./IntakeModelStatus";
export type {
  IntakeOptionCardProps,
  IntakeOptionIndicator,
} from "./IntakeOptionCard";
export { IntakeOptionCard } from "./IntakeOptionCard";
export type { IntakeProductPickerProps } from "./IntakeProductPicker";
export { IntakeProductPicker } from "./IntakeProductPicker";
export type {
  IntakeRadioListProps,
  RadioListItem,
} from "./IntakeRadioList";
export { IntakeRadioList } from "./IntakeRadioList";
export type {
  IntakeRefineRowProps,
  IntakeRefineRowVariant,
} from "./IntakeRefineRow";
export { IntakeRefineRow } from "./IntakeRefineRow";
export type { IntakeSourceBadgeProps } from "./IntakeSourceBadge";
export { IntakeSourceBadge } from "./IntakeSourceBadge";
export type { IntegrationsProps } from "./Integrations";
export { Integrations } from "./Integrations";
export type {
  LoadingEstimate,
  LoadingSequenceProps,
} from "./LoadingSequence";
export { LoadingSequence } from "./LoadingSequence";
export type {
  MarketplaceLookupProduct,
  MarketplaceProductLookupProps,
} from "./MarketplaceProductLookup";
export { MarketplaceProductLookup } from "./MarketplaceProductLookup";
export type {
  MetricDefinitionReviewItem,
  MetricDefinitionReviewProps,
} from "./MetricDefinitionReview";
export { MetricDefinitionReview } from "./MetricDefinitionReview";
export type {
  MetricReviewCardProps,
  MetricReviewStatus,
} from "./MetricReviewCard";
export { MetricReviewCard } from "./MetricReviewCard";
export type {
  MetricReviewQueueItem,
  MetricReviewQueueItemStatus,
  MetricReviewQueueProps,
} from "./MetricReviewQueue";
export { MetricReviewQueue } from "./MetricReviewQueue";
export type { MetricRevisionControlsProps } from "./MetricRevisionControls";
export { MetricRevisionControls } from "./MetricRevisionControls";
export type { MetricsPickerProps } from "./MetricsPicker";
export { MetricsPicker } from "./MetricsPicker";
export type { ProductFitCheckingProps } from "./ProductFitChecking";
export { ProductFitChecking } from "./ProductFitChecking";
export type { ProductFitWarningProps } from "./ProductFitWarning";
export { ProductFitWarning } from "./ProductFitWarning";
export type { ProductGridProps } from "./ProductGrid";
export { ProductGrid } from "./ProductGrid";
export type {
  ProductSearchProduct,
  ProductSearchProps,
} from "./ProductSearch";
export { ProductSearch } from "./ProductSearch";
export type { PromptHeaderProps } from "./PromptHeader";
export { PromptHeader } from "./PromptHeader";
export type { RailHomeProps } from "./RailHome";
export { RailHome } from "./RailHome";
export type { ReportCitationMarkerProps } from "./ReportCitationMarker";
export { ReportCitationMarker } from "./ReportCitationMarker";
export type { ReportComparableVendorsProps } from "./ReportComparableVendors";
export { ReportComparableVendors } from "./ReportComparableVendors";
export type { ReportExecSummaryProps } from "./ReportExecSummary";
export { ReportExecSummary } from "./ReportExecSummary";
export type { ReportFiguresListProps } from "./ReportFiguresList";
export { ReportFiguresList } from "./ReportFiguresList";
export type { ReportHeaderBadgesProps } from "./ReportHeaderBadges";
export {
  ReportHeaderBadges,
  scopeTileSentence,
} from "./ReportHeaderBadges";
export type { ReportKeyRisksProps } from "./ReportKeyRisks";
export { ReportKeyRisks } from "./ReportKeyRisks";
export type { ReportMetricsListProps } from "./ReportMetricsList";
export { ReportMetricsList } from "./ReportMetricsList";
export type { ReportOverviewProps } from "./ReportOverview";
export { ReportOverview } from "./ReportOverview";
export type { ReportPendingNoticeProps } from "./ReportPendingNotice";
export { ReportPendingNotice } from "./ReportPendingNotice";
export type { ReportSectionHeadingProps } from "./ReportSectionHeading";
export { ReportSectionHeading } from "./ReportSectionHeading";
export type { ReportSectionPlaceholderProps } from "./ReportSectionPlaceholder";
export { ReportSectionPlaceholder } from "./ReportSectionPlaceholder";
export type { ReportShellProps, ReportShellSectionProps } from "./ReportShell";
export { ReportShell, ReportShellSection } from "./ReportShell";
export type {
  ReportSourceFlashTarget,
  ReportSourcesProps,
} from "./ReportSources";
export { ReportSources } from "./ReportSources";
export type { ReportTileGridProps, ReportTileProps } from "./ReportTile";
export { ReportTile, ReportTileGrid } from "./ReportTile";
export type { ReportVendorRationaleProps } from "./ReportVendorRationale";
export { ReportVendorRationale } from "./ReportVendorRationale";
export type {
  ReportSummaryProduct,
  ReportViewProps,
} from "./ReportView";
export { ReportView } from "./ReportView";
export type { BuildReportFiguresInput } from "./report-figures";
export { buildReportFigureRows, buildReportFigures } from "./report-figures";
export {
  computedReportFixture,
  partialReportFixture,
  pendingReportFixture,
} from "./report-fixtures";
export {
  formatHorizonYears,
  formatReportUsd,
  REPORT_EMPTY_VALUE,
} from "./report-format";
export type {
  ReportProseAssertion,
  ReportProseSegment,
  ReportValueRef,
  ResolvedProseSegment,
} from "./report-prose";
export { resolveReportProse, validateProseAssertions } from "./report-prose";
export type {
  OpenAssumptionHandler,
  OpenAssumptionsHandler,
  ReportAttribution,
  ReportClaim,
  ReportComparableVendor,
  ReportData,
  ReportExecSummaryBullet,
  ReportFigureKey,
  ReportFigureRow,
  ReportFigures,
  ReportMetricRow,
  ReportMetricShift,
  ReportProblem,
  ReportRationaleRow,
  ReportScope,
  ReportScopeOrigin,
  ReportScopeTile,
  ReportSectionId,
  ReportSectionMeta,
  ReportSource,
  ReportStreamRow,
  ReportTraceAggregate,
  ReportTraceContributor,
  ReportTraceHistoryEntry,
  ReportTraceKnownInput,
  ReportTraceNode,
  ReportTraceNodeKind,
  ReportTraceTarget,
} from "./report-types";
export { REPORT_SECTIONS } from "./report-types";
export type { SourceListProps } from "./SourceList";
export { SourceList } from "./SourceList";
export type { StaleModalCardProps } from "./StaleModalCard";
export { StaleModalCard } from "./StaleModalCard";
export type { SuggestedReplyProps } from "./SuggestedReply";
export { SuggestedReply } from "./SuggestedReply";
export type { TwoOptionSelectProps } from "./TwoOptionSelect";
// Smart components
export { TwoOptionSelect } from "./TwoOptionSelect";
export type { UpdatesPanelProps } from "./UpdatesPanel";
export { UpdatesPanel } from "./UpdatesPanel";
export type { UserBubbleProps } from "./UserBubble";
export { UserBubble } from "./UserBubble";
